export const BRANCHES = [
  {
    id: 'technique',
    title: 'Technique',
    color: '#4ade80',
    rgb: '74, 222, 128',
    children: [
      // SUBCATEGORY 1.1: DEFENSE
      {
        id: 'tech-defense',
        title: 'Defense',
        children: [
          // GROUP 1.1.1: DIRECT
          {
            id: 'tech-def-direct',
            title: 'Direct',
            children: [
              // GROUP 1.1.1.1: FOREHAND
              {
                id: 'tech-def-direct-fh',
                title: 'Forehand',
                children: [
                  // SUB-GROUP 1.1.1.1.1: FLAT
                  {
                    id: 'tech-def-direct-fh-flat',
                    title: 'Flat',
                    children: [
                      { id: 'tech-def-direct-fh-flat-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-flat-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-flat-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-flat-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.1.1.2: SLICE
                  {
                    id: 'tech-def-direct-fh-slice',
                    title: 'Slice',
                    children: [
                      { id: 'tech-def-direct-fh-slice-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-slice-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-slice-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-slice-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.1.1.3: LOB (with Full Lob and Fast Lob)
                  {
                    id: 'tech-def-direct-fh-lob',
                    title: 'Lob',
                    children: [
                      // SUB-GROUP 1.1.1.1.3.1: FULL LOB
                      {
                        id: 'tech-def-direct-fh-lob-full',
                        title: 'Full Lob',
                        children: [
                          { id: 'tech-def-direct-fh-lob-full-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-fh-lob-full-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-fh-lob-full-power', title: 'Power', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-fh-lob-full-height', title: 'Height', children: [], maxRating: 3 },
                        ],
                      },
                      // SUB-GROUP 1.1.1.1.3.2: FAST LOB
                      {
                        id: 'tech-def-direct-fh-lob-fast',
                        title: 'Fast Lob',
                        children: [
                          { id: 'tech-def-direct-fh-lob-fast-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-fh-lob-fast-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-fh-lob-fast-power', title: 'Power', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-fh-lob-fast-height', title: 'Height', children: [], maxRating: 3 },
                        ],
                      },
                    ],
                  },
                  // SUB-GROUP 1.1.1.1.4: CONTRAPARED
                  {
                    id: 'tech-def-direct-fh-contrapared',
                    title: 'Contrapared',
                    children: [
                      { id: 'tech-def-direct-fh-contrapared-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-contrapared-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-contrapared-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-fh-contrapared-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                ],
              },
              // GROUP 1.1.1.2: BACKHAND
              {
                id: 'tech-def-direct-bh',
                title: 'Backhand',
                children: [
                  // SUB-GROUP 1.1.1.2.1: FLAT
                  {
                    id: 'tech-def-direct-bh-flat',
                    title: 'Flat',
                    children: [
                      { id: 'tech-def-direct-bh-flat-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-flat-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-flat-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-flat-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.1.2.2: SLICE
                  {
                    id: 'tech-def-direct-bh-slice',
                    title: 'Slice',
                    children: [
                      { id: 'tech-def-direct-bh-slice-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-slice-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-slice-power', title: 'Power', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-slice-height', title: 'Height', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.1.2.3: LOB (with Full Lob and Fast Lob)
                  {
                    id: 'tech-def-direct-bh-lob',
                    title: 'Lob',
                    children: [
                      // SUB-GROUP 1.1.1.2.3.1: FULL LOB
                      {
                        id: 'tech-def-direct-bh-lob-full',
                        title: 'Full Lob',
                        children: [
                          { id: 'tech-def-direct-bh-lob-full-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-bh-lob-full-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-bh-lob-full-power', title: 'Power', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-bh-lob-full-height', title: 'Height', children: [], maxRating: 3 },
                        ],
                      },
                      // SUB-GROUP 1.1.1.2.3.2: FAST LOB
                      {
                        id: 'tech-def-direct-bh-lob-fast',
                        title: 'Fast Lob',
                        children: [
                          { id: 'tech-def-direct-bh-lob-fast-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-bh-lob-fast-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-bh-lob-fast-power', title: 'Power', children: [], maxRating: 3 },
                          { id: 'tech-def-direct-bh-lob-fast-height', title: 'Height', children: [], maxRating: 3 },
                        ],
                      },
                    ],
                  },
                  // SUB-GROUP 1.1.1.2.4: CONTRAPARED
                  {
                    id: 'tech-def-direct-bh-contrapared',
                    title: 'Contrapared',
                    children: [
                      { id: 'tech-def-direct-bh-contrapared-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-contrapared-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-contrapared-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-def-direct-bh-contrapared-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                ],
              },
            ],
          },
          // GROUP 1.1.2: OFF THE GLASS
          {
            id: 'tech-def-ofglass',
            title: 'Off the Glass',
            children: [
              // GROUP 1.1.2.1: FOREHAND
              {
                id: 'tech-def-ofglass-fh',
                title: 'Forehand',
                children: [
                  // SUB-GROUP 1.1.2.1.1: FLAT
                  {
                    id: 'tech-def-ofglass-fh-flat',
                    title: 'Flat',
                    children: [
                      { id: 'tech-def-ofglass-fh-flat-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-fh-flat-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-fh-flat-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-fh-flat-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.2.1.2: SLICE
                  {
                    id: 'tech-def-ofglass-fh-slice',
                    title: 'Slice',
                    children: [
                      { id: 'tech-def-ofglass-fh-slice-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-fh-slice-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-fh-slice-power', title: 'Power', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-fh-slice-height', title: 'Height', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.2.1.3: LOB (with Full Lob and Fast Lob)
                  {
                    id: 'tech-def-ofglass-fh-lob',
                    title: 'Lob',
                    children: [
                      // SUB-GROUP 1.1.2.1.3.1: FULL LOB
                      {
                        id: 'tech-def-ofglass-fh-lob-full',
                        title: 'Full Lob',
                        children: [
                          { id: 'tech-def-ofglass-fh-lob-full-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-fh-lob-full-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-fh-lob-full-power', title: 'Power', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-fh-lob-full-height', title: 'Height', children: [], maxRating: 3 },
                        ],
                      },
                      // SUB-GROUP 1.1.2.1.3.2: FAST LOB
                      {
                        id: 'tech-def-ofglass-fh-lob-fast',
                        title: 'Fast Lob',
                        children: [
                          { id: 'tech-def-ofglass-fh-lob-fast-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-fh-lob-fast-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-fh-lob-fast-power', title: 'Power', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-fh-lob-fast-height', title: 'Height', children: [], maxRating: 3 },
                        ],
                      },
                    ],
                  },
                ],
              },
              // GROUP 1.1.2.2: BACKHAND
              {
                id: 'tech-def-ofglass-bh',
                title: 'Backhand',
                children: [
                  // SUB-GROUP 1.1.2.2.1: FLAT
                  {
                    id: 'tech-def-ofglass-bh-flat',
                    title: 'Flat',
                    children: [
                      { id: 'tech-def-ofglass-bh-flat-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-bh-flat-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-bh-flat-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-bh-flat-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.2.2.2: SLICE
                  {
                    id: 'tech-def-ofglass-bh-slice',
                    title: 'Slice',
                    children: [
                      { id: 'tech-def-ofglass-bh-slice-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-bh-slice-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-bh-slice-power', title: 'Power', children: [], maxRating: 3 },
                      { id: 'tech-def-ofglass-bh-slice-height', title: 'Height', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.1.2.2.3: LOB (with Full Lob and Fast Lob)
                  {
                    id: 'tech-def-ofglass-bh-lob',
                    title: 'Lob',
                    children: [
                      // SUB-GROUP 1.1.2.2.3.1: FULL LOB
                      {
                        id: 'tech-def-ofglass-bh-lob-full',
                        title: 'Full Lob',
                        children: [
                          { id: 'tech-def-ofglass-bh-lob-full-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-bh-lob-full-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-bh-lob-full-height', title: 'Height', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-bh-lob-full-power', title: 'Power', children: [], maxRating: 3 },
                        ],
                      },
                      // SUB-GROUP 1.1.2.2.3.2: FAST LOB
                      {
                        id: 'tech-def-ofglass-bh-lob-fast',
                        title: 'Fast Lob',
                        children: [
                          { id: 'tech-def-ofglass-bh-lob-fast-depth', title: 'Depth', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-bh-lob-fast-direction', title: 'Direction', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-bh-lob-fast-height', title: 'Height', children: [], maxRating: 3 },
                          { id: 'tech-def-ofglass-bh-lob-fast-power', title: 'Power', children: [], maxRating: 3 },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          // GROUP 1.1.3: RETURN
          {
            id: 'tech-def-return',
            title: 'Return',
            children: [
              // GROUP 1.1.3.1: RIGHT
              {
                id: 'tech-def-return-right',
                title: 'Right',
                children: [
                  { id: 'tech-def-return-right-hard', title: 'Hard', children: [], maxRating: 3 },
                  { id: 'tech-def-return-right-lob', title: 'Lob', children: [], maxRating: 3 },
                  { id: 'tech-def-return-right-contrapared', title: 'Contrapared', children: [], maxRating: 3 },
                  { id: 'tech-def-return-right-chiquita', title: 'Chiquita', children: [], maxRating: 3 },
                ],
              },
              // GROUP 1.1.3.2: LEFT
              {
                id: 'tech-def-return-left',
                title: 'Left',
                children: [
                  { id: 'tech-def-return-left-hard', title: 'Hard', children: [], maxRating: 3 },
                  { id: 'tech-def-return-left-lob', title: 'Lob', children: [], maxRating: 3 },
                  { id: 'tech-def-return-left-contrapared', title: 'Contrapared', children: [], maxRating: 3 },
                  { id: 'tech-def-return-left-chiquita', title: 'Chiquita', children: [], maxRating: 3 },
                ],
              },
            ],
          },
        ],
      },
      // SUBCATEGORY 1.2: OFFENSE
      {
        id: 'tech-attack',
        title: 'Attack',
        children: [
          // GROUP 1.2.1: FOREHAND VOLLEY
          {
            id: 'tech-att-fh-volley',
            title: 'Forehand Volley',
            children: [
              // SUB-GROUP 1.2.1.1: FLAT
              {
                id: 'tech-att-fh-volley-flat',
                title: 'Flat',
                children: [
                  { id: 'tech-att-fh-volley-flat-depth', title: 'Depth', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-flat-direction', title: 'Direction', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-flat-height', title: 'Height', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-flat-power', title: 'Power', children: [], maxRating: 3 },
                ],
              },
              // SUB-GROUP 1.2.1.2: SLICE
              {
                id: 'tech-att-fh-volley-slice',
                title: 'Slice',
                children: [
                  { id: 'tech-att-fh-volley-slice-depth', title: 'Depth', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-slice-direction', title: 'Direction', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-slice-power', title: 'Power', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-slice-height', title: 'Height', children: [], maxRating: 3 },
                ],
              },
              // SUB-GROUP 1.2.1.3: DROPSHOT
              {
                id: 'tech-att-fh-volley-dropshot',
                title: 'Dropshot',
                children: [
                  { id: 'tech-att-fh-volley-dropshot-depth', title: 'Depth', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-dropshot-direction', title: 'Direction', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-dropshot-touch', title: 'Touch', children: [], maxRating: 3 },
                  { id: 'tech-att-fh-volley-dropshot-height', title: 'Height', children: [], maxRating: 3 },
                ],
              },
            ],
          },
          // GROUP 1.2.2: BACKHAND VOLLEY
          {
            id: 'tech-att-bh-volley',
            title: 'Backhand Volley',
            children: [
              // SUB-GROUP 1.2.2.1: FLAT
              {
                id: 'tech-att-bh-volley-flat',
                title: 'Flat',
                children: [
                  { id: 'tech-att-bh-volley-flat-depth', title: 'Depth', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-flat-direction', title: 'Direction', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-flat-height', title: 'Height', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-flat-power', title: 'Power', children: [], maxRating: 3 },
                ],
              },
              // SUB-GROUP 1.2.2.2: SLICE
              {
                id: 'tech-att-bh-volley-slice',
                title: 'Slice',
                children: [
                  { id: 'tech-att-bh-volley-slice-depth', title: 'Depth', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-slice-direction', title: 'Direction', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-slice-height', title: 'Height', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-slice-power', title: 'Power', children: [], maxRating: 3 },
                ],
              },
              // SUB-GROUP 1.2.2.3: DROPSHOT
              {
                id: 'tech-att-bh-volley-dropshot',
                title: 'Dropshot',
                children: [
                  { id: 'tech-att-bh-volley-dropshot-depth', title: 'Depth', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-dropshot-direction', title: 'Direction', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-dropshot-touch', title: 'Touch', children: [], maxRating: 3 },
                  { id: 'tech-att-bh-volley-dropshot-height', title: 'Height', children: [], maxRating: 3 },
                ],
              },
            ],
          },
          // GROUP 1.2.3: OVERHEAD
          {
            id: 'tech-att-overhead',
            title: 'Overhead',
            children: [
              // SUB-GROUP 1.2.3.1: FLAT SMASH
              {
                id: 'tech-att-overhead-flat',
                title: 'Flat Smash',
                children: [
                  // SUB-GROUP 1.2.3.1.1: GANCHO
                  {
                    id: 'tech-att-overhead-flat-gancho',
                    title: 'Gancho',
                    children: [
                      { id: 'tech-att-overhead-flat-gancho-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-gancho-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-gancho-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-gancho-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.2.3.1.2: X4
                  {
                    id: 'tech-att-overhead-flat-x4',
                    title: 'x4',
                    children: [
                      { id: 'tech-att-overhead-flat-x4-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-x4-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-x4-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-x4-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.2.3.1.3: BOUNCE BACK
                  {
                    id: 'tech-att-overhead-flat-bounceback',
                    title: 'Bounce Back',
                    children: [
                      { id: 'tech-att-overhead-flat-bounceback-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-bounceback-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-bounceback-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-flat-bounceback-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                ],
              },
              // SUB-GROUP 1.2.3.2: TOPSPIN SMASH
              {
                id: 'tech-att-overhead-topspin',
                title: 'Topspin Smash',
                children: [
                  // SUB-GROUP 1.2.3.2.1: RULO
                  {
                    id: 'tech-att-overhead-topspin-rulo',
                    title: 'Rulo',
                    children: [
                      { id: 'tech-att-overhead-topspin-rulo-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-topspin-rulo-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-topspin-rulo-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-topspin-rulo-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.2.3.2.2: X3
                  {
                    id: 'tech-att-overhead-topspin-x3',
                    title: 'x3',
                    children: [
                      { id: 'tech-att-overhead-topspin-x3-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-topspin-x3-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-topspin-x3-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-topspin-x3-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                ],
              },
              // SUB-GROUP 1.2.3.3: VIBORA
              {
                id: 'tech-att-overhead-vibora',
                title: 'Vibora',
                children: [
                  { id: 'tech-att-overhead-vibora-depth', title: 'Depth', children: [], maxRating: 3 },
                  { id: 'tech-att-overhead-vibora-direction', title: 'Direction', children: [], maxRating: 3 },
                  { id: 'tech-att-overhead-vibora-height', title: 'Height', children: [], maxRating: 3 },
                  { id: 'tech-att-overhead-vibora-power', title: 'Power', children: [], maxRating: 3 },
                ],
              },
              // SUB-GROUP 1.2.3.4: BAJADA
              {
                id: 'tech-att-overhead-bajada',
                title: 'Bajada',
                children: [
                  // SUB-GROUP 1.2.3.4.1: FOREHAND
                  {
                    id: 'tech-att-overhead-bajada-fh',
                    title: 'Forehand',
                    children: [
                      { id: 'tech-att-overhead-bajada-fh-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-bajada-fh-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-bajada-fh-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-bajada-fh-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                  // SUB-GROUP 1.2.3.4.2: BACKHAND
                  {
                    id: 'tech-att-overhead-bajada-bh',
                    title: 'Backhand',
                    children: [
                      { id: 'tech-att-overhead-bajada-bh-depth', title: 'Depth', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-bajada-bh-direction', title: 'Direction', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-bajada-bh-height', title: 'Height', children: [], maxRating: 3 },
                      { id: 'tech-att-overhead-bajada-bh-power', title: 'Power', children: [], maxRating: 3 },
                    ],
                  },
                ],
              },
            ],
          },
          // GROUP 1.2.4: SERVE
          {
            id: 'tech-att-serve',
            title: 'Serve',
            children: [
              { id: 'tech-att-serve-power', title: 'Power', children: [], maxRating: 3 },
              { id: 'tech-att-serve-direction', title: 'Direction', children: [], maxRating: 3 },
              { id: 'tech-att-serve-height', title: 'Height', children: [], maxRating: 3 },
              { id: 'tech-att-serve-spin', title: 'Spin', children: [], maxRating: 3 },
              { id: 'tech-att-serve-depth', title: 'Depth', children: [], maxRating: 3 },
            ],
          },
        ],
      },
    ],
  },
  // TACTICS BRANCH
  {
    id: 'tactics',
    title: 'Tactics',
    color: '#38bdf8',
    rgb: '56, 189, 248',
    children: [
      // Back of the Court
      {
        id: 'tact-back-court',
        title: 'Back of the Court',
        children: [
          { id: 'tact-back-court-positioning', title: 'Positioning', children: [], maxRating: 3 },
          { id: 'tact-back-court-shot-selection', title: 'Shot-Selection', children: [], maxRating: 3 },
          { id: 'tact-back-court-range-shots', title: 'Range of Shots', children: [], maxRating: 3 },
          { id: 'tact-back-court-anticipation', title: 'Anticipation', children: [], maxRating: 3 },
        ],
      },
      // At the Net
      {
        id: 'tact-net',
        title: 'At the Net',
        children: [
          { id: 'tact-net-positioning', title: 'Positioning', children: [], maxRating: 3 },
          { id: 'tact-net-shot-selection', title: 'Shot-Selection', children: [], maxRating: 3 },
          { id: 'tact-net-range-shots', title: 'Range of Shots', children: [], maxRating: 3 },
          { id: 'tact-net-anticipation', title: 'Anticipation', children: [], maxRating: 3 },
        ],
      },
      // Transition
      {
        id: 'tact-transition',
        title: 'Transition',
        children: [
          { id: 'tact-transition-positioning', title: 'Positioning', children: [], maxRating: 3 },
          { id: 'tact-transition-shot-selection', title: 'Shot-Selection', children: [], maxRating: 3 },
          { id: 'tact-transition-range-shots', title: 'Range of Shots', children: [], maxRating: 3 },
          { id: 'tact-transition-anticipation', title: 'Anticipation', children: [], maxRating: 3 },
        ],
      },
      // Communication
      {
        id: 'tact-communication',
        title: 'Communication',
        children: [
          { id: 'tact-communication-accuracy', title: 'Accuracy', children: [], maxRating: 3 },
          { id: 'tact-communication-speed', title: 'Speed', children: [], maxRating: 3 },
          { id: 'tact-communication-clarity', title: 'Clarity', children: [], maxRating: 3 },
        ],
      },
      // Strategy
      {
        id: 'tact-strategy',
        title: 'Strategy',
        children: [
          { id: 'tact-strategy-adaptation', title: 'Adaptation', children: [], maxRating: 3 },
          { id: 'tact-strategy-analysis', title: 'Analysis', children: [], maxRating: 3 },
          { id: 'tact-strategy-imposition', title: 'Imposition', children: [], maxRating: 3 },
          { id: 'tact-strategy-reliability', title: 'Reliability', children: [], maxRating: 3 },
        ],
      },
    ],
  },
  // BRAWN BRANCH - Athletic & Physical Performance
  {
    id: 'brawn',
    title: 'Brawn',
    color: '#fb923c',
    rgb: '251, 146, 60',
    children: [
      // CATEGORY 1: POWER
      {
        id: 'brawn-power',
        title: 'Power',
        children: [
          { id: 'brawn-power-generation', title: 'Power Generation', children: [], maxRating: 3 },
          { id: 'brawn-power-explosive', title: 'Explosive Strength', children: [], maxRating: 3 },
        ],
      },
      // CATEGORY 2: SPEED
      {
        id: 'brawn-speed',
        title: 'Speed',
        children: [
          { id: 'brawn-speed-movement', title: 'Movement Speed', children: [], maxRating: 3 },
          { id: 'brawn-speed-acceleration', title: 'Acceleration', children: [], maxRating: 3 },
        ],
      },
      // CATEGORY 3: STAMINA
      {
        id: 'brawn-stamina',
        title: 'Stamina',
        children: [
          { id: 'brawn-stamina-endurance', title: 'Match Endurance', children: [], maxRating: 3 },
          { id: 'brawn-stamina-recovery', title: 'Point Recovery', children: [], maxRating: 3 },
        ],
      },
      // CATEGORY 4: FOOTWORK
      {
        id: 'brawn-footwork',
        title: 'Footwork',
        children: [
          { id: 'brawn-footwork-coverage', title: 'Court Coverage', children: [], maxRating: 3 },
          { id: 'brawn-footwork-efficiency', title: 'Movement Efficiency', children: [], maxRating: 3 },
        ],
      },
      // CATEGORY 5: MOBILITY
      {
        id: 'brawn-mobility',
        title: 'Mobility (ROM)',
        children: [
          { id: 'brawn-mobility-range', title: 'Range of Motion', children: [], maxRating: 3 },
          { id: 'brawn-mobility-flexibility', title: 'Flexibility', children: [], maxRating: 3 },
        ],
      },
      // CATEGORY 6: RECOVERY
      {
        id: 'brawn-recovery',
        title: 'Recovery',
        children: [
          { id: 'brawn-recovery-between-points', title: 'Between-Point Recovery', children: [], maxRating: 3 },
          { id: 'brawn-recovery-physical', title: 'Physical Recovery', children: [], maxRating: 3 },
        ],
      },
      // CATEGORY 7: TIMING
      {
        id: 'brawn-timing',
        title: 'Timing',
        children: [
          { id: 'brawn-timing-shot', title: 'Shot Timing', children: [], maxRating: 3 },
          { id: 'brawn-timing-awareness', title: 'Court Awareness', children: [], maxRating: 3 },
        ],
      },
    ],
  },
];

// ─── NODE DESCRIPTIONS ────────────────────────────────────────────────────────
// Short coaching notes shown on long-press of a skill node.
export const NODE_DESCRIPTIONS = {
  // Top-level branches
  'technique':            'The complete technical skill set — defense, attack, and beyond.',
  'tactics':              'Reading the game, positioning, and decision-making under pressure.',
  'brawn':         'Physical and mental fitness to sustain peak performance.',

  // Defense branches
  'tech-defense':         'Defensive techniques — controlled returns that reset the rally.',
  'tech-def-direct':      'Direct returns hit cleanly off the opponent\'s shot.',
  'tech-def-direct-fh':   'Forehand direct returns — the most common defensive shot in padel.',
  'tech-def-direct-bh':   'Backhand direct returns — crucial for handling balls to your left side.',
  'tech-def-direct-fh-flat':   'Flat forehand — neutral, controlled reset. Low risk, keeps the rally alive.',
  'tech-def-direct-fh-slice':  'Forehand slice — low bounce, tricky for opponents to attack.',
  'tech-def-direct-fh-lob':    'Forehand lob — a tactical weapon to push opponents back from the net.',
  'tech-def-direct-fh-contrapared': 'Contrapared FH — using the back wall intentionally to redirect the ball.',
  'tech-def-direct-bh-flat':   'Flat backhand — reliable block, great for pace absorption.',
  'tech-def-direct-bh-slice':  'Backhand slice — spinning away from opponents to create time.',
  'tech-def-direct-bh-lob':    'Backhand lob — defensive reset that can flip point control.',
  'tech-def-direct-bh-contrapared': 'Contrapared BH — redirecting off the back wall on the backhand side.',

  // Off-glass branches
  'tech-def-ofglass':     'Off-glass returns — reading the rebound angle off the back or side wall.',
  'tech-def-ofglass-fh':  'Forehand off-glass — timing a shot after the ball ricochets off glass.',
  'tech-def-ofglass-bh':  'Backhand off-glass — maintaining position while reading the glass angle.',
  'tech-def-ofglass-fh-flat':  'Flat off-glass FH — neutral return after reading the glass, no spin.',
  'tech-def-ofglass-fh-slice': 'Slice off-glass FH — cutting under the ball for a controlled low return.',
  'tech-def-ofglass-fh-lob':   'Lob off-glass FH — lifting the ball deep to reset positioning.',
  'tech-def-ofglass-bh-flat':  'Flat off-glass BH — clean strike on the backhand after glass read.',
  'tech-def-ofglass-bh-slice': 'Slice off-glass BH — spinning the ball away with backspin.',
  'tech-def-ofglass-bh-lob':   'Lob off-glass BH — defensive height to buy time and reset.',

  'tech-def-return':       'Return of serve — breaking serve with aggressive or tactical shot selection.',
  'tech-def-return-right': 'Return from right court — returning serves coming from the server\'s left side.',
  'tech-def-return-right-hard': 'Right hard return — aggressive flat return to pressure the server.',
  'tech-def-return-right-lob': 'Right lob return — defensive lob to push server back from net.',
  'tech-def-return-right-contrapared': 'Right contrapared return — tricky angled return off the serve.',
  'tech-def-return-right-chiquita': 'Right chiquita return — soft, angled return drop on the return side.',
  'tech-def-return-left': 'Return from left court — returning serves coming from the server\'s right side.',
  'tech-def-return-left-hard': 'Left hard return — aggressive flat return from the left side.',
  'tech-def-return-left-lob': 'Left lob return — defensive lob to reset positioning.',
  'tech-def-return-left-contrapared': 'Left contrapared return — angled return with backspin.',
  'tech-def-return-left-chiquita': 'Left chiquita return — soft drop return with touch control.',

  // Offense branches
  'tech-attack':         'Offensive techniques — aggressive shots that create pressure or finish points.',
  'tech-att-serve':      'Serve technique — initiating the point with controlled power and placement.',
  'tech-att-serve-power': 'Serve power — generating pace and force to pressure the returner.',
  'tech-att-serve-direction': 'Serve direction — placing the serve to specific court zones (body, wide, T-line).',
  'tech-att-serve-height': 'Serve height — controlling the ball\'s arc and bounce height for tactical advantage.',
  'tech-att-serve-spin': 'Serve spin — applying topspin, slice, or flat techniques to affect ball trajectory.',
  'tech-att-serve-depth': 'Serve depth — controlling how deep into the court the serve lands.',
  'tech-att-fh-volley':   'Forehand volley at the net — the primary weapon for closing out points.',
  'tech-att-bh-volley':   'Backhand volley — controlling the net with your non-dominant side.',
  'tech-att-overhead':    'Overhead shots — smashes and kills from above shoulder height.',
  'tech-att-fh-volley-flat':    'Flat FH volley — firm, direct punch volley. Fast and reliable.',
  'tech-att-fh-volley-slice':   'Slice FH volley — cutting angle off the volley; hard to retrieve.',
  'tech-att-fh-volley-dropshot': 'Forehand dropshot volley — soft touch at the net to drop the ball close to the net line.',
  'tech-att-fh-volley-dropshot-depth': 'Dropshot volley FH depth — controlling how close to the net the ball lands.',
  'tech-att-fh-volley-dropshot-direction': 'Dropshot volley FH direction — placing the soft volley to avoid opponent reach.',
  'tech-att-fh-volley-dropshot-touch': 'Dropshot volley FH touch — soft hands and control for delicate net play.',
  'tech-att-fh-volley-dropshot-height': 'Dropshot volley FH height — keeping the ball low over the net for a winning shot.',
  'tech-att-bh-volley-flat':    'Flat BH volley — direct backhand punch at the net.',
  'tech-att-bh-volley-slice':   'Slice BH volley — angled slice that skids away from opponents.',
  'tech-att-bh-volley-dropshot': 'Backhand dropshot volley — soft touch at the net to drop the ball close to the net line.',
  'tech-att-bh-volley-dropshot-depth': 'Dropshot volley BH depth — controlling how close to the net the ball lands.',
  'tech-att-bh-volley-dropshot-direction': 'Dropshot volley BH direction — placing the soft volley to avoid opponent reach.',
  'tech-att-bh-volley-dropshot-touch': 'Dropshot volley BH touch — soft hands and control for delicate net play.',
  'tech-att-bh-volley-dropshot-height': 'Dropshot volley BH height — keeping the ball low over the net for a winning shot.',
  'tech-att-overhead-flat':     'Flat overhead — power kill shot. Maximum pace through the court.',
  'tech-att-overhead-topspin':  'Topspin overhead — kicks deep into the court or bounces out of reach.',
  'tech-att-overhead-vibora':   'Vibora (snake) — snake-like topspin overhead. Bounces violently sideways to the walls; one of the highest-skill shots in padel.',
  'tech-att-overhead-flat-gancho':    'Gancho (hook) — flat overhead hooking into the side wall at low height.',
  'tech-att-overhead-flat-x4':        'X4 — a cross-court flat overhead aimed at the back corner where the wall meets the glass.',
  'tech-att-overhead-flat-bounceback': 'Bounceback — overhead aimed to bounce off the back glass and return into the court.',
  'tech-att-overhead-topspin-rulo':   'Rulo — a spinning overhead looped sideways into the wall; forces a difficult retrieval.',
  'tech-att-overhead-bajada':    'Bajada — the descending attack from overhead. Taking the ball aggressively off the glass, redirecting downward into the court.',
  'tech-att-overhead-bajada-fh': 'Bajada Forehand — aggressive FH overhead drop-and-strike off the glass. A powerful offensive weapon.',
  'tech-att-overhead-bajada-fh-depth':  'Bajada FH depth — controlling how deep into the court the shot lands after the glass.',
  'tech-att-overhead-bajada-fh-direction': 'Bajada FH direction — placing the aggressive drop-strike to avoid opponent reach.',
  'tech-att-overhead-bajada-fh-height':   'Bajada FH height — keeping the ball low after the glass for a winning shot.',
  'tech-att-overhead-bajada-fh-power':    'Bajada FH power — generating explosive force through the aggressive downward strike.',
  'tech-att-overhead-bajada-bh': 'Bajada Backhand — explosive BH overhead drop-and-strike off the glass. A weapon when mastered.',
  'tech-att-overhead-bajada-bh-depth':  'Bajada BH depth — controlling how deep into the court the backhand shot lands.',
  'tech-att-overhead-bajada-bh-direction': 'Bajada BH direction — placing the aggressive backhand drop to avoid opponent reach.',
  'tech-att-overhead-bajada-bh-height':   'Bajada BH height — keeping the backhand strike low over the net for a winner.',
  'tech-att-overhead-bajada-bh-power':    'Bajada BH power — generating explosive force on the backhand aggressive drop-strike.',

  // Tactics branches
  'tact-back-court':           'Defensive positioning and decision-making from the baseline.',
  'tact-back-court-positioning': 'Court positioning at the baseline — depth, angles, and court coverage.',
  'tact-back-court-shot-selection': 'Choosing the right defensive shot based on opponent position and court situation.',
  'tact-back-court-range-shots': 'Variety of shots available from the back court — flat, slice, lob, and more.',
  'tact-back-court-anticipation': 'Reading the opponent\'s intentions to anticipate the next shot.',

  'tact-net':                  'Aggressive positioning and finishing plays at the net.',
  'tact-net-positioning':      'Net control — distance management and angle coverage for volley dominance.',
  'tact-net-shot-selection':   'Selecting finishing shots based on ball trajectory and opponent location.',
  'tact-net-range-shots':      'Repertoire of net shots — volleys, dropshots, and tactical placement.',
  'tact-net-anticipation':     'Predicting opponent movement to intercept and finish points.',

  'tact-transition':           'Moving from baseline to net — the most critical tactical phase.',
  'tact-transition-positioning': 'Proper footwork and court position during the advance to the net.',
  'tact-transition-shot-selection': 'Aggressive shots that allow safe approach to the net.',
  'tact-transition-range-shots': 'Attacking shots available during transition — drives, attacking lobs, and drops.',
  'tact-transition-anticipation': 'Reacting quickly to opponent returns while advancing forward.',

  'tact-serve':                'Serve placement and strategy to gain advantage.',
  'tact-serve-positioning':    'Server positioning and court setup before serving.',
  'tact-serve-shot-selection': 'Strategic serve placement — direction, depth, and spin.',
  'tact-serve-range-shots':    'Serve variations — wide, body, T, with different speeds and spins.',
  'tact-serve-anticipation':   'Reading return position to anticipate the returner\'s response.',

  'tact-return':               'Return of serve strategy and execution.',
  'tact-return-positioning':   'Returner positioning and court setup for optimal return angles.',
  'tact-return-shot-selection': 'Selecting return strategy based on serve placement and pace.',
  'tact-return-range-shots':   'Return variations — aggressive, neutral, and defensive options.',
  'tact-return-anticipation':  'Predicting server movement to break serve effectively.',

  'tact-communication':        'Partner coordination and communication on court.',
  'tact-communication-accuracy': 'Clear and precise communication with your partner.',
  'tact-communication-speed':  'Quick communication to adjust tactics mid-rally.',
  'tact-communication-clarity': 'Effective signals and calls to coordinate positioning and strategy.',

  'tact-strategy':             'Overall match strategy and tactical adjustments.',
  'tact-strategy-adaptation':  'Adjusting tactics when opponents change their play style.',
  'tact-strategy-analysis':    'Reading and analyzing opponent weaknesses and patterns.',
  'tact-strategy-imposition':  'Imposing your game style and game plan on opponents.',
  'tact-strategy-reliability': 'Consistent execution of your tactical strategy under pressure.',

  // Brawn branches - Physical & Athletic Performance
  'brawn-power':                'Explosive strength and force generation for aggressive shots and quick movements.',
  'brawn-power-generation':     'Pure power generation — ability to produce maximum force in shots and movements.',
  'brawn-power-explosive':      'Explosive strength — fast-twitch muscle engagement for sudden, explosive bursts.',

  'brawn-speed':                'Court speed and agility — how quickly you can move and accelerate across the court.',
  'brawn-speed-movement':       'Overall movement speed — covering distance efficiently and rapidly on court.',
  'brawn-speed-acceleration':   'Acceleration capacity — ability to change pace and speed quickly during rallies.',

  'brawn-stamina':              'Energy endurance — maintaining peak performance throughout long matches.',
  'brawn-stamina-endurance':    'Match endurance — sustaining intensity through multiple sets and tiebreaks.',
  'brawn-stamina-recovery':     'Point recovery — ability to catch your breath and reset energy between points.',

  'brawn-footwork':             'Movement efficiency and court positioning — precise footwork under pressure.',
  'brawn-footwork-coverage':    'Court coverage — ability to reach all areas of the court efficiently.',
  'brawn-footwork-efficiency':  'Movement efficiency — economy of motion and optimal step patterns.',

  'brawn-mobility':             'Range of motion and flexibility — maintaining full mobility and injury prevention.',
  'brawn-mobility-range':       'Range of motion — achieving full joint movement for defensive reaches.',
  'brawn-mobility-flexibility': 'Flexibility — muscle elasticity and joint mobility for injury prevention.',

  'brawn-recovery':             'Physical recovery capacity — bouncing back from exertion and preparation.',
  'brawn-recovery-between-points': 'Between-point recovery — heart rate control and quick mental reset.',
  'brawn-recovery-physical':    'Physical recovery — muscle recovery and fatigue management during matches.',

  'brawn-timing':               'Movement timing and rhythm — synchronizing footwork with ball arrival.',
  'brawn-timing-shot':          'Shot timing — hitting the ball at the optimal moment in its trajectory.',
  'brawn-timing-awareness':     'Court timing awareness — synchronizing position changes with opponent actions.',
};

// ─── SKILL PATH RESOLUTION ────────────────────────────────────────────────────
// Leaf titles alone are ambiguous - "Depth", "Power", "Positioning" etc. each
// appear under dozens of different parent branches, so any UI that lists a
// skill outside the tree itself (priority skill checklists, notifications)
// needs the full ancestor chain, not just the leaf's own title.

// Returns the array of node titles from the top-level branch down to (and
// including) the given skillId, e.g. ['Technique', 'Defense', 'Direct',
// 'Forehand', 'Flat', 'Depth']. Returns null if the id isn't found.
export function findNodeTitlePath(skillId, nodes = BRANCHES, path = []) {
  for (const node of nodes) {
    const nextPath = [...path, node.title];
    if (node.id === skillId) return nextPath;
    if (node.children && node.children.length > 0) {
      const found = findNodeTitlePath(skillId, node.children, nextPath);
      if (found) return found;
    }
  }
  return null;
}

// Human-readable "breadcrumb" name for a skill, e.g.
// "Defense › Direct › Forehand › Flat › Depth". Drops the redundant
// top-level "Technique" wrapper (Defense/Attack are self-descriptive on
// their own); Tactics/Brawn keep their top-level label since it's
// meaningful. Falls back to the raw id if the skill can't be found (e.g. the
// tree structure changed since a priority was assigned).
export function getSkillFullName(skillId) {
  const path = findNodeTitlePath(skillId);
  if (!path) return skillId;
  const trimmed = path[0] === 'Technique' ? path.slice(1) : path;
  return trimmed.join(' › ');
}
